/**
 * Custom redirect function that stores the current location and redirects to platform login
 * Uses sessionStorage to restore user location after successful login
 */
export const redirectToPlatformLoginPageWithReturn = () => {
  const encodedRedirectUrl = encodeURIComponent(window.location.href);

  window.location.assign(
    `${import.meta.env.PLATFORM_BASE_URL}/login?redirectUri=${encodedRedirectUrl}`,
  );
};
